import React from 'react';
import { styled } from 'linaria/lib/react';
import { Accordion, theme } from '@mtsbank/ui-kit';
export const AccordionItem = () => <AccordionWrapper>
    <CustomAccordionItem domMounted items={accordionTestData} variant="privateBanking" size="sm" />
  </AccordionWrapper>;
const AccordionWrapper = /*#__PURE__*/styled("div")({
  name: "AccordionWrapper",
  class: "azj5mce"
});
const CustomAccordionItem = /*#__PURE__*/styled(Accordion)({
  name: "CustomAccordionItem",
  class: "c3wcqhs"
});
const accordionTestData = [
// {
//   title: 'Какие игровые кошельки можно пополнить?',
//   text: 'Через наш сервис вы можете пополнить кошельки Steam, Playstation, Xbox, Battle.net и других игр',
// },
// {
//   title: 'Как пополнить игровые кошельки?',
//   text: 'Вы можете купить ваучер для пополнения кошельков Steam, Playstation, Xbox, Battle.net и других игр. Также, можно пополнить баланс Steam напрямую',
// },
// {
//   title: 'Что такое логин Steam?',
//   text: `Это комбинация букв, цифр и\u00A0знака «_», которую вы\u00A0указываете при\u00A0входе в\u00A0Steam.

//   Если при\u00A0оплате введете неверный логин\u00A0— деньги уйдут на\u00A0аккаунт другого игрока.`,
// },
// {
//   title: 'За пополнение игровых кошельков есть комиссия?',
//   text: 'Вы не платите комиссию при покупке игровых ваучеров и пополнении кошелька Steam, если оплачиваете картами МТС Банка. При оплате с карт других банков будет комиссия 50 ₽. При пополнении кошелька Steam также удерживается комиссия за конвертацию — до 10%. Возможна дополнительная комиссия, если оплачиваете кредитной картой',
// },
{
  title: 'С\u00A0каких карт можно пополнять игровые кошельки?',
  text: 'С\u00A0любых российских банковских карт.'
}, {
  title: 'Что такое ваучер?',
  text: 'Вaучер\u00A0— уникaльнaя комбинaция из\u00A0цифр и\u00A0букв. У\u00A0вaучера есть денежный номинaл, который зачисляется на\u00A0игровой кошелек при\u00A0активации.'
}, {
  title: 'Как получить ваучер после оплаты?',
  text: 'Ваучер и\u00A0инструкцию по\u00A0активации пришлём в\u00A0течение 15\u00A0минут после оплаты на\u00A0ваш e-mail. В\u00A0редких случаях\u00A0- до\u00A03\u00A0часов.'
},
// {
//   title: 'Можно ли пополнить российские игровые аккаунты с помощью ваучера?',
//   text: 'Нет, ваучер можно активировать только для аккаунта США',
// },
// {
//   title: 'Как быстро зачисляются деньги на\u00A0игровой кошелек?',
//   text: `Деньги придут на\u00A0кошелек в\u00A0течение 15\u00A0минут. В\u00A0редких случаях\u00A0— до\u00A02\u00A0часов.

//   Если деньги не\u00A0пришли в\u00A0течение нескольких часов, позвоните нам по\u00A0телефонам:

//   +7\u00A0495\u00A0777\u2011000\u20111\u00A0— для Москвы и\u00A0МО
//   8\u00A0800\u00A0250\u201105\u201120\u00A0— для других регионов

//   Мы\u00A0проверим платеж и\u00A0постараемся помочь.`,
// },
// {
//   title: 'Что такое зарубежная карта\u00A0и какой у\u00A0нее функционал?',
//   text: `Это предоплаченная карта зарубежного банка. Карта полностью анонимная, выпускается без данных о\u00A0держателе и\u00A0идентификации в\u00A0банке. Выпуск карт не\u00A0ограничен\u00A0— можно получить несколько карт за\u00A0раз.

//   У\u00A0карты нет расчётного счёта и\u00A0пополнить её\u00A0нельзя.

//   Картой можно платить в\u00A0магазинах и интернет-магазинах, которые не\u00A0требуют подтверждения операций по\u00A03D\u00A0Secure.
//   `,
// },
{
  title: 'Что делать, если не\u00A0пришло письмо с\u00A0ваучером?',
  text: `Проверьте в\u00A0почте папку Спам. Если письма там нет, позвоните в\u00A0контактный центр по\u00A0номеру 8\u00A0800\u00A0250\u201105\u201120\u00A0— поможем разобраться в\u00A0проблеме.
    
    Обращения, поступившие в\u00A0субботу и воскресенье, будут обработаны в\u00A0понедельник.`
},
// {
//   title: 'Что делать, если не\u00A0проходит оплата при\u00A0пополнении аккаунта Steam?',
//   text: 'Убедитесь, что VPN отключен при\u00A0совершении платежа. Если ошибка сохраняется, позвоните в\u00A0контактный центр по\u00A0номеру 8\u00A0800\u00A0250\u201105\u201120\u00A0— поможем разобраться в\u00A0проблеме.',
// },
{
  title: 'Можно ли\u00A0вернуть деньги за\u00A0ваучер после покупки?',
  text: `К\u00A0сожалению, нет. Ваучер невозвратный.
    
    Если возникли сложности с\u00A0активацией ваучера\u00A0— позвоните нам по\u00A0номеру 8\u00A0800\u00A0250\u201105\u201120, и\u00A0мы\u00A0поможем его активировать.

    Обращения, поступившие в\u00A0субботу и воскресенье, будут обработаны в\u00A0понедельник.
    `
}
// {
//   title: 'Можно\u00A0ли вернуть деньги, если ошибся в\u00A0логине при\u00A0пополнении Steam?',
//   text: 'Если введенный логин существует\u00A0— деньги вернуть не\u00A0получится. Если введенного логина нет в\u00A0Steam, деньги вернутся обратно на\u00A0счет карты, с\u00A0которой пополняли аккаунт.',
// },
// {
//   title: 'Что такое виртуальная карта МТS CASHBACK?',
//   text: (
//     <>
//       МТS CASHBACK — виртуальная карта с преимуществами обычной пластиковой карты. Получайте кешбэк за покупки,
//       переводите деньги, снимайте наличные в банкоматах c технологией бесконтактной оплаты.{' '}
//       <Link target="_blank" href={NEW_CARD_URL}>
//         Подробнее о карте
//       </Link>
//     </>
//   ),
// },
// {
//   title: 'Что такое кешбэк?',
//   text: (
//     <>
//       Это бонусы от сервиса{' '}
//       <Link target="_blank" href={CASHBACK_URL}>
//         МТС Cashback
//       </Link>
//       , которые можно потратить на покупки в магазинах МТС, оплату мобильной связи, интернета и ТВ, билеты на
//       мероприятия и другие развлечения
//     </>
//   ),
// },
// {
//   title: 'Сколько кешбэка начисляется за пополнение игровых кошельков?',
//   text: (
//     <>
//       Начислится 3% кешбэка, если пополняете игровые кошельки{' '}
//       <Link target="_blank" href={MAIN_PATH}>
//         на сайте
//       </Link>
//       . Срок начисления кешбэка ограничен — до 31 декабря 2023 года
//     </>
//   ),
// },
];

require("./Accordion.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./Accordion.tsx");